export enum VideoAvatarPosition {
  AVATAR_LEFT_W_SLIDE = 'avatar-left-w-slide',
  AVATAR_RIGHT_W_SLIDE = 'avatar-right-w-slide',
  AVATAR_CENTER_W_SLIDE = 'avatar-center-w-slide',
  SLIDE_ONLY = 'slide-only',
  AVATAR_ONLY = 'avatar-only',
}
